<template>
    <!-- Responsive home page layout -->
    <v-app>
        <v-container>
            <v-row justify="center">
                <!-- Navigation Bar -->
                <v-col cols="12" class="mb-8">
                    <NavBar :pageTitle="pageTitle" />
                </v-col>
                <v-col cols="12" class="flex-box">
                    <v-card outlined class="text-pure-white bg-aqua-teal">
                        <v-card-title class="text-center text-wrap">{{ pageTitle }}</v-card-title>
                        <v-card-text>
                            {{ pageDescription }}
                        </v-card-text>
                    </v-card>
                </v-col>

                <!-- Display content in v-col below. -->
                <v-col cols="12">
                    <div class="flex-box">
                        <ToggleButton v-model="contentType.choiceNumber" :value-string="contentType.choiceName"
                            @update:valueString="newValue => contentType.choiceName = newValue" />
                    </div>
                </v-col>
                <v-divider class="border-opacity-25"></v-divider>
                <v-col cols="12">
                    <div class="flex-box">
                            <ListContent :items="getFilteredContent" :contentId="contentId" />
                        
                    </div>
                </v-col>
                <v-divider class="border-opacity-25"></v-divider>

                <!-- Expansion Panels for Main Page Content -->
                <v-col cols="12">
                    <div v-if="getItemContent.length > 0" class="d-flex justify-end mb-2">
                        <v-btn-toggle>
                            <v-btn v-show="expandValue == 0" @click="setPanels(0)" icon="mdi-arrow-collapse" />
                            <v-btn v-show="expandValue == 1" @click="setPanels(1)" icon="mdi-arrow-expand" />
                        </v-btn-toggle>
                    </div>
                    <v-expansion-panels v-model="openedPanels" multiple>
                        <template v-if="getItemContent.length > 0">
                            <v-expansion-panel v-for="content in getItemContent" :key="content.pageContentId">
                                <template v-slot:title>
                                    {{ content.item }}
                                </template>

                                <v-expansion-panel-text>
                                    <p v-if="content.itemDescription"> {{ content.itemDescription }}</p>
                                    <p v-else> No description available. </p>
                                    <div class="d-flex justify-end"
                                        v-if="content.subpages[0].hasOwnProperty('subPageId')">
                                        <v-btn @click="navigateToSubPage(content.subpages[0].subPageId)"
                                            class="bg-aqua-teal text-pure-white mt-4">
                                            Learn More </v-btn>
                                    </div>
                                </v-expansion-panel-text>

                            </v-expansion-panel>
                        </template>
                    </v-expansion-panels>
                </v-col>
            </v-row>
        </v-container>
        <!-- Footer -->
        <MENDFooter></MENDFooter>
    </v-app>
</template>

<script>
import ListContent from './ListContent.vue';
import MENDFooter from './MENDFooter.vue';
import NavBar from './NavBar.vue';
import ToggleButton from './ToggleButton.vue';
import axios from 'axios';

export default {
    name: 'PageComponent',
    components: {
        ListContent,
        MENDFooter,
        NavBar,
        ToggleButton,
    },
    props: {
        pageid: String,
        contentId: {
            type: String,
            required: false
        }
    },
    watch: {
        // If pageid is changed, retrieve relevant content.
        pageid() {
            this.fetchData();
        },
        openedPanels() {
            if (this.openedPanels.length === this.getItemContent.length) {
                this.expandValue = 0;
            } else if (this.openedPanels.length === 0) {
                this.expandValue = 1;
            }
        }
    },
    data() {
        return {
            contentType: {
                choiceNumber: 0,
                choiceName: 'Video'
            },
            openedPanels: [],
            page: [],
            expandValue: 1
        };
    },
    mounted() {
        this.fetchData();
        //console.log('ContentId:', this.contentId)
    },
    methods: {
        async fetchData() {
            if (this.pageid === "#") {
                this.page = [];
                console.log("ANGER");
                return;
            }
            try {
                axios.defaults.baseURL = process.env.VUE_APP_API_URL;
                const response = await axios.get(`/api/page/${this.pageid}`);
                this.page = response.data;
            } catch (error) {
                console.log(error);
                this.page = []; // Set to empty array if there's an error
            }
        },
        navigateToSubPage(subPageId) {
            this.$router.push({ name: 'SubPage', params: { subpageid: subPageId } });
        },
        listHasEntry() {
            return this.page.length > 0;
        },
        setPanels(value) {
            if (this.getItemContent) {
                this.openedPanels = [];
                if (value === 1) {
                    for (let i = 0; i < this.getItemContent.length; i++) {
                        this.openedPanels.push(i);
                    }
                }

                this.expandValue = (this.expandValue === 0) ? 1 : 0;
            }
        },
    },
    computed: {
        getContent() {   // Get page content list
            if (!this.listHasEntry) return [];
            return this.page.pagecontents;
        },
        pageDescription() {  // Get page description
            if (!this.listHasEntry) return '';
            return this.page.pageDescription;
        },
        pageTitle() {  // Get page title
            if (!this.listHasEntry) return 'Content Unavailable';
            return this.page.pageTitle;
        },
        getFilteredContent() {
            if (!this.listHasEntry) return [];
            const content = this.page.pagecontents || [];
            var filtered = content.filter(
                (item) => item.contentBlock === this.contentType.choiceName
            );
            console.log(this.contentType.choiceName, ": ", filtered);
            return filtered;
        },
        getItemContent() {
            if (!this.listHasEntry) return [];
            const content = this.page.pagecontents || [];
            const modifiedContent = content.filter((item) => item.contentBlock === "Items");
            for (let i = 0; i < modifiedContent.length; i++) {
                if (modifiedContent[i].subpages.length === 0) {
                    modifiedContent[i].subpages = [{}];
                }
            }
            return modifiedContent
        }
    }
};
</script>

<style scoped>
* {
    font-family: 'Montserrat';
}

.flex-box {
    display: flex;
    justify-content: center;
}

.text-pure-white {
    color: #FFFFFF;
}

.bg-aqua-teal {
    background-color: #08B6AA;
}

.subpage-link {
    color: #08B6AA;
    cursor: pointer;
    text-decoration: underline;
}

.text-center {
    text-align: center;
}
</style>
